// Material
import { Divider, Grid, Typography } from '@mui/material'

// Components
import { ProductLine, LineDetail, Expanded, Box } from '@arredo/reactjs-ui';

const SurchargeLine = (index, surcharge, currency) => {
  switch (surcharge?.code) {
    case 'INTERES':
      return <LineDetail key={index} title='Interes' surcharges currency={currency} price={surcharge.amount} />;
    case 'BANKREFUND':
      return <LineDetail key={index} title='Recargo bancario' surcharges currency={currency} price={surcharge.amount} />;
    case 'Redondeo':
      return <LineDetail key={index} title='Redondeo' surcharges currency={currency} price={surcharge.amount} />;
    case 'ARTCOSTO':
      return <LineDetail key={index} title='Costo de envío' surcharges currency={currency} price={surcharge.amount} />;
    default:
      return null;
  }
}

const getShippingItem = items =>
  items
    ?.filter(i => i.code === 'ARTCOSTO')
    .reduce((accumulator, item) => accumulator ? { ...accumulator, amount: accumulator.amount + item.amount } : item, null);

const TaxInfo = ({ voucher }) =>
  <Box header={
    <Grid size={12}>
      <Typography>Detalle de Venta</Typography>
    </Grid>}
  >
    <Grid container spacing={1}>
      {voucher?.items
        ?.filter(i => i.code !== 'ARTCOSTO')
        .filter(i => i.amount > 0).map(item =>
          <Grid key={item.code} size={12}>
            <ProductLine key={item.code} item={item} discounts={voucher.discounts} currency={voucher.currency} />
          </Grid>
        )}
      {voucher.items?.filter(i => i.amount < 0).length > 0 && (
        <Grid size={12}>
          <Expanded
            discount
            title='Productos Devueltos:'
            currency={voucher.currency}
            amount={voucher.items?.filter(i => i.amount < 0)
              .reduce((accumulator, item) => accumulator + item.amount, 0) * -1}
          >
            {voucher.items?.filter(i => i.amount < 0).map(item =>
              <LineDetail
                discount
                variant='body2'
                key={item.code}
                title={item.name}
                price={item.price}
                quantity={item.quantity * -1}
                currency={voucher.currency}
              />)}
          </Expanded>
        </Grid>
      )}
      {voucher.perceptions?.length > 0 &&
        <Grid size={12}>
          <Expanded
            surcharges
            title='Percepciones:'
            currency={voucher.currency}
            amount={voucher.perceptions
              .reduce((accumulator, item) => accumulator + item.amount, 0)}
          >
            {voucher.perceptions.map((item, index) =>
              <LineDetail
                surcharges
                variant='body2'
                key={index}
                title={item.name}
                price={item.amount}
                quantity={item.quantity}
                currency={voucher.currency}
              />)}
          </Expanded>
        </Grid>}
      {voucher.surcharges?.map((surcharge, index) => SurchargeLine(index, surcharge, voucher.currency))}
      {SurchargeLine("ARTCOSTO", getShippingItem(voucher.items), voucher.currency)}
      <Grid size={12}>
        <Divider />
      </Grid>
      <Grid size={12}>
        <LineDetail variant='h5' title='Total' currency={voucher.currency} price={voucher.amount} />
      </Grid>
    </Grid>
  </Box>

export default TaxInfo
